<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fLSwPf/tc-custom/9781455609987.jpg?1705035153828" alt="This image is the cover for the book Dinosaur's Night Before Christmas, The Night Before Christmas"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Dinosaur's Night Before Christmas, The Night Before Christmas
      </h1>
      <p class="bookDescription body article font2">
        <p><b>To save Christmas, a father and son must battle eight not-so-tiny dinosaurs . . .</b></p><p> It’s Christmas Eve and Dad is up late, testing a game for his son. A sudden ruckus outside brings him to his feet, and when he looks into the sky, he can hardly believe his eyes. Eight gigantic dinosaurs are pulling a strange UFO across the sky! </p><p> It isn’t long before this night before Christmas turns into a nightmare. The ferocious dinosaurs—Smasher, Splinter, Crusher, Fang, Biter, Slang, Stomper and a mean, mighty T-Rex dressed like an evil St. Nick—soon start destroying the neighborhood, gobbling up the presents, and ruining Christmas. </p><p> When Dad meets the real Santa Claus, the two of them, along with some amazing bubble gum, a powerful video gun, and some surprise helpers, engage in one epic battle to save Christmas. Imaginatively detailed illustrations from award-winning artist Jim Harris turn this hilarious and fantastic Christmas story into a larger-than-life Jurassic adventure! </p><p><b>Acclaim for Jim Harris’s <i>The Three Little Dinosaurs</i></b></p><p> “Charming illustrations . . . The humorous text depicts these modern beasts playing video games, ordering pizza, and talking about insurance.” —<i>School Library Journal</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jim Harris
      </h2>
      
      <p class="authorDescription body article"> Award-winning illustrator Jim Harris has delighted audiences of all ages with his eye-popping artwork. Among his many accolades are the prestigious Society of Illustrators silver medal and the&#160;<I>Communication Arts&rsquo;</I>&#160;Award of Excellence. Children&rsquo;s Television Workshop, IBM, and the National Wildlife Federation are among the many organizations and private collectors that have commissioned Harris&rsquo;s artwork. Harris is the illustrator of&#160;<B><I>Librarian&rsquo;s Night Before Christmas</I></B>&#160;and&#160;<B><I>Tuesday in Arizona,</I></B>&#160;and the author and illustrator of&#160;<B><I>The Three Little Dinosaurs,</I></B>&#160;all available from Pelican. He resides in Nelson, New Zealand. </p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Pelican Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cb9fa34a